import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {TableModule} from "primeng/table";
import {PaginatorModule} from "primeng/paginator";
import {CalendarModule} from "primeng/calendar";
import {TabViewModule} from "primeng/tabview";
import {AccordionModule} from "primeng/accordion";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {PreloadAllModules, RouterModule, Routes} from "@angular/router";
import {AppComponent} from "./app.component";
import {HomepageComponent} from "./homepage/homepage.component";
import {FileUploadModule} from "primeng/fileupload";

import {CommonModule, DatePipe} from "@angular/common";
import {GruppoComponent} from "./gruppo/gruppo.component";
import {ServiziMondoComponent} from "./servizi-mondo/servizi-mondo.component";
import {ContattiComponent} from "./contatti/contatti.component";
import {SostenibilitaComponent} from "./sostenibilita/sostenibilita.component";
import {InvestorComponent} from "./investor/investor.component";
import {AreeComponent} from "./aree/aree.component";
import {StoriaComponent} from "./storia/storia.component";
import {BannersComponent} from "./components/banners/banners.component";
import {PagesDefaultComponent} from "./components/pages-default/pages-default.component";
import {HttpClientModule} from "@angular/common/http";
import {MessagesModule} from "primeng/messages";
import {MessageModule} from "primeng/message";
import {CorporateComponent} from "./corporate/corporate.component";
import {ComponentiGenericiComponent} from "./componenti-generici/componenti-generici.component";
import {PagesWithTablestComponent} from "./components/pages-with-tables/pages-with-tables.component";
import {PagesWithTabstComponent} from "./components/pages-with-tabs/pages-with-tabs.component";
import {PagesWithTabsTimeComponent} from "./components/pages-with-tabs-time/pages-with-tabs-time.component";
import {PictureGalleryComponent} from "./components/picture-gallery/picture-gallery.component";
import {
    PagesWithTabsWithoutDateComponent
} from "./components/pages-with-tabs-without-date/pages-with-tabs-without-date.component";
import {PagesWithUploadstComponent} from "./components/pages-with-uploads/pages-with-uploads.component";
import {DisclaimerComponent} from "./disclaimer/disclaimer.component";
import {SlickCarouselModule} from "ngx-slick-carousel";
import {SidebarModule} from "primeng/sidebar";
import {PagesFullWidthComponent} from "./components/pages-full-width/pages-full-width.component";
import {PagesTitoliSriComponent} from "./components/pages-titoli-sri/pages-titoli-sri.component";
import {SocietaTrasparenteComponent} from "./societa-trasparente/societa-trasparente.component";
import {NgxSpinnerComponent} from "./shared/ngx-spinner/ngx-spinner.component";
import {BlockUIModule} from "primeng/blockui";
import {LeafletModule} from "@asymmetrik/ngx-leaflet";
import {MenuServiceGuard} from "./service/guard/menu.service.guard";
import {NgxMasonryModule} from "ngx-masonry";
import {SafePipe} from "./pipe/safe.pipe";

import {OrderPipe} from "./pipe/order.pipe";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormrequestComponent} from "./formrequest/formrequest.component";

import {RecaptchaFormsModule, RecaptchaModule} from "ng-recaptcha";
import {
    NgcCookieConsentModule,
    NgcCookieConsentConfig,
} from "ngx-cookieconsent";
import {NotFoundComponent} from "./not-found/not-found.component";

const cookieConfig: NgcCookieConsentConfig = {
    enabled: true,
    cookie: {
        domain: "servizitaliagroup.com", // -<< must be 'localhost'
        expiryDays: 7,
    },
    palette: {
        popup: {
            background: "#252e39",
        },
        button: {
            background: "#14a7d0",
        },
    },
    position: "bottom-right",
    theme: "edgeless",
    type: "opt-out",
    content: {
        link: "Cookie Policy.",
        dismiss: "Non Acconsento",
        allow: "Accetta i cookie analitici",
        deny: "Non Acconsento",
        href: "https://www.servizitaliagroup.com/cookie-policy",
        message:
            "Questo sito o gli strumenti terzi da questo utilizzati usano cookies tecnici necessari " +
            " al funzionamento di questo sito web e cookies finalizzati al miglioramento dell’esperienza di navigazione. " +
            "Non installiamo cookies opzionali senza il suo consenso. Per maggiori informazioni e modificare le " +
            "impostazioni sui cookies utilizzati consulti la nostra " +
            ' <a href="https://www.servizitaliagroup.com/cookie-policy">Privacy Policy.</a>',
    },
    showLink: false,
};

export const IT = "IT";
export const EN = "EN";
export const PT = "PT";
export const routing: Routes = [
    {path: "", redirectTo: "homepage", pathMatch: "full"},


    {
        path: "homepage",
        component: HomepageComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },


    {
        path: "homepage-en",
        component: HomepageComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "fesr",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },

    {
        path: "gruppo",
        component: GruppoComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "gruppo/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "group",
        component: GruppoComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "group/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "grupo",
        component: GruppoComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: PT},
    },
    {
        path: "grupo/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: PT},
    },


    {
        path: "investor-relations",
        component: InvestorComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "investor-relations/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "investor-relations-en",
        component: InvestorComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "investor-relations-en/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "societa-trasparente",
        component: SocietaTrasparenteComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },

    {
        path: "societa-trasparente/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },

    {
        path: "transparent-company",
        component: SocietaTrasparenteComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "transparent-company/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "corporate-governance",
        component: CorporateComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "corporate-governance/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },

    {
        path: "corporate-governance-en",
        component: CorporateComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "corporate-governance-en/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },


    {
        path: "contatti",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "contacts",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "contatos",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: PT},
    },

    {
        path: "privacy",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "cookie-policy",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },

    // DA GESTIRE
    {
        path: "privacy-en",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "disclaimer",
        component: DisclaimerComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },

    // DA GESTIRE
    {
        path: "disclaimer-en",
        component: DisclaimerComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "faq",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "faq-en",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "sostenibilita",
        component: SostenibilitaComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "sostenibilita/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "sustainability",
        component: SostenibilitaComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "sustainability/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },
    {
        path: "sustentabilidade",
        component: SostenibilitaComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: PT},
    },
    {
        path: "sustentabilidade/:id",
        component: ComponentiGenericiComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: PT},
    },

    {
        path: "servizi-italia-nel-mondo",
        component: ServiziMondoComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: IT},
    },
    {
        path: "servizi-italia-in-the-world",
        component: ServiziMondoComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: EN},
    },

    {
        path: "servizi-italia-no-mundo",
        component: ServiziMondoComponent,
        canActivate: [MenuServiceGuard],
        data: {lang: PT},
    },

    {path: "**", component: NotFoundComponent},
];

@NgModule({
    declarations: [
        AppComponent,
        HomepageComponent,
        GruppoComponent,
        ServiziMondoComponent,
        ContattiComponent,
        SostenibilitaComponent,
        InvestorComponent,
        AreeComponent,
        StoriaComponent,
        BannersComponent,
        PagesDefaultComponent,
        PagesTitoliSriComponent,
        PagesWithTabsWithoutDateComponent,
        PagesWithTablestComponent,
        PagesWithTabsTimeComponent,
        PagesWithTabstComponent,
        PagesWithUploadstComponent,
        SocietaTrasparenteComponent,
        PictureGalleryComponent,
        CorporateComponent,
        ComponentiGenericiComponent,
        DisclaimerComponent,
        PagesFullWidthComponent,
        NgxSpinnerComponent,
        SafePipe,
        OrderPipe,
        FormrequestComponent,
        NotFoundComponent,
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        TableModule,
        PaginatorModule,
        CalendarModule,
        TabViewModule,
        ReactiveFormsModule,
        FormsModule,
        FileUploadModule,
        AccordionModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routing, {
            useHash: false,
            preloadingStrategy: PreloadAllModules,
            onSameUrlNavigation: "reload",
            scrollPositionRestoration: "enabled",
        }),
        CommonModule,
        MessageModule,
        MessagesModule,
        SidebarModule,
        SlickCarouselModule,
        BlockUIModule,
        LeafletModule.forRoot(),
        NgxMasonryModule,
        RecaptchaModule,
        NgcCookieConsentModule.forRoot(cookieConfig),
        RecaptchaFormsModule,
    ],
    providers: [DatePipe],
    bootstrap: [AppComponent],
})
export class AppModule {
}
